import { toObject } from "../../core/utils";
import isNil from "lodash/fp/isNil";

class BackupSchedulePageTransform {
  constructor() {
    "ngInject";
  }

  justify(data) {
    const format = (data) => {
      if (!isNil(data.city.timezone)) {
        const itemTimezoneDiff = data.city.timezone;
        data.start_time -= itemTimezoneDiff;
        data.end_time -= itemTimezoneDiff;
      }
      if (!isNil(data.ride_category)) {
        data.ride_category.label = `${data.ride_category.ride_type} ${data.ride_category.service_type}`;
      }
      return data;
    };
    return toObject(format(data));
  }
}

export default BackupSchedulePageTransform;



// WEBPACK FOOTER //
// ./src/pages/backupSchedule/backupSchedule.transforms.js